import { useEffect, useState } from 'react';
import { desktop, type LicenseStatus } from '../platform';

/**
 * Desktop only: this computer's license, the same file the plugins read, kept current as it is
 * synced, refreshed or removed. Null in a browser and until the app has answered.
 */
export function useLicenseStatus(): LicenseStatus | null {
  const [status, setStatus] = useState<LicenseStatus | null>(null);
  useEffect(() => {
    if (!desktop) return;
    let alive = true;
    desktop.license.status().then((s) => alive && setStatus(s));
    const off = desktop.license.onChange((s) => setStatus(s));
    return () => {
      alive = false;
      off();
    };
  }, []);
  return status;
}
